var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("p", [
    _vm._v(_vm._s(_vm.Lang.get("messages.change_status_confirmation")) + " "),
    _vm.message
      ? _c("span", [_vm._v("( " + _vm._s(_vm.message) + " )")])
      : _vm._e(),
    _vm._v("?"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }